import axios from "axios";
import AuthenticationService from "@/services/AuthenticationService";
import store from "@/store";

const BimsHttpService = axios.create({
    baseURL: process.env.VUE_APP_API_BASE_URL,
});

BimsHttpService.defaults.headers.common['Accepts'] = 'application/json';
BimsHttpService.interceptors.response.use(response => response, error => {
    const status = error.response ? error.response.status : null;

    if (status === 401) {
        // will loop if refreshToken returns 401
        return AuthenticationService.getApiAccessToken().then(() =>{
            const accessToken = store.getters.user.accessToken;
            error.config.headers['Authorization'] = 'Bearer ' + accessToken;
            // This will retry the original request
            return BimsHttpService.request(error.config);
        });
    }

    return Promise.reject(error);
});

export default BimsHttpService;
